import { touchWebClient, webApiClient } from 'tradera/utils/http';

export const followSeller = async (sellerId) =>
    touchWebClient.post(`/my/favourite-sellers/add`, { sellerId });

export const unfollowSeller = async (sellerId) =>
    touchWebClient.post(`/my/favourite-sellers/remove`, { ids: [sellerId] });

export const getSimilarSellerSuggestions = async (
    sellerMemberId,
    maxSellers,
    keepSellersWithNoItems
) =>
    webApiClient.get(
        `/discover/similar-seller-suggestions?sellerMemberId=${sellerMemberId}&MaxSellers=${maxSellers}&KeepSellersWithNoItems=${keepSellersWithNoItems}`
    );
